import { createContext } from 'react';

import type { ETabsKeys } from './consts';

type TabsContextType = {
  setActiveTab: (tab: ETabsKeys) => void;
};

export const SchoolEditPageTabContext = createContext<TabsContextType>({} as TabsContextType);
